import { Fragment, useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { HiBars3, HiBuildingLibrary, HiShieldCheck, HiXMark } from "react-icons/hi2";

import Nav from "../main/Nav";
import Footer from "../main/Footer";
import classes from "./Layout.module.css";
import { bankName } from "../../util/config";

const Layout = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!menuOpen) {
      return undefined;
    }
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [menuOpen]);

  return (
    <Fragment>
      <div className={classes.app}>
        <header className={classes.header}>
          <div className={classes.headerInner}>
            <div className={classes.topRow}>
              <Link to="/" className={classes.brand}>
                <HiBuildingLibrary className={classes.brandIcon} aria-hidden />
                {bankName}
              </Link>
              <div className={classes.topActions}>
                <span className={classes.badge}>
                  <HiShieldCheck className={classes.badgeIcon} aria-hidden />
                  Administration
                </span>
                <button
                  type="button"
                  className={classes.menuBtn}
                  onClick={() => setMenuOpen((prev) => !prev)}
                  aria-label={menuOpen ? "Close menu" : "Open menu"}
                  aria-expanded={menuOpen}
                  aria-controls="admin-mobile-nav"
                >
                  {menuOpen ? (
                    <HiXMark className={classes.menuBtnIcon} aria-hidden />
                  ) : (
                    <HiBars3 className={classes.menuBtnIcon} aria-hidden />
                  )}
                </button>
              </div>
            </div>
            <div className={classes.desktopNav}>
              <Nav />
            </div>
          </div>
        </header>
        <div
          className={`${classes.drawerBackdrop} ${menuOpen ? classes.backdropOpen : ""}`}
          onClick={() => setMenuOpen(false)}
          aria-hidden={!menuOpen}
        />
        <aside
          id="admin-mobile-nav"
          className={`${classes.mobileDrawer} ${menuOpen ? classes.drawerOpen : ""}`}
          aria-hidden={!menuOpen}
        >
          <div className={classes.mobileDrawerHead}>
            <span>Navigation</span>
            <button
              type="button"
              className={classes.drawerClose}
              onClick={() => setMenuOpen(false)}
              aria-label="Close menu"
            >
              <HiXMark className={classes.menuBtnIcon} aria-hidden />
            </button>
          </div>
          <Nav onNavigate={() => setMenuOpen(false)} />
        </aside>
        <main className={classes.main}>
          {/*
            Avoid AnimatePresence mode="wait" around <Outlet /> — it conflicts with
            the data router and can leave the outlet blank until a full reload.
          */}
          <motion.div
            key={location.pathname}
            className={classes.outlet}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.18, ease: [0.22, 1, 0.36, 1] }}
          >
            <Outlet />
          </motion.div>
        </main>
        <Footer />
      </div>
    </Fragment>
  );
};

export default Layout;
